export const styles = () => ({
  root: {},
});
